<script setup>
import {inject, onMounted, provide, ref} from "vue";
import useComment, {USE_COMMENT_KEY} from "./comments/CommentComposition";
import useNickname, {USE_NICKNAME_KEY} from "./comments/NicknameComposition";
import PostContainer from "./components/PostContainer.vue";
import CommentThreads from "./comments/CommentThreads.vue";
import DirectComment from "./comments/DirectComment.vue";
import {ClientJS} from "clientjs";

const siteUrl = document.querySelector('meta[name="site-url"]').content;

const commentComposition = useComment();
provide(USE_COMMENT_KEY, commentComposition);

const nicknameComposition = useNickname(siteUrl);
provide(USE_NICKNAME_KEY, nicknameComposition);

const postId = inject('postId');
const userId = inject('userId');

// 描画投稿データ
const post = ref(null);

// ページを読み込む
const init = async () => {
  try {
    // 取得を試みる
    const response = await fetch(siteUrl+'place/get-post/'+postId+'?fingerprint='+(new ClientJS()).getFingerprint());

    // JSON パースを試みる
    const data = await response.json();

    // 追加
    post.value = data.post;

    // 共感情報があればセット
    if (data.empathy) {
      post.value.is_empathy = Boolean(data.empathy.post);
    }

    // コメントをセット
    commentComposition.init(
      data.comments,
      data.commentViolations,
      userId,
      data.post.id,
      data.post.user_nickname_id,
      data.isMyPost,
      Number(data.post.accept_comments_type) !== 0,
      data.draftComments
    );

    // ニックネームを取得
    nicknameComposition.init(data.nicknames);
  }

    // 特に何もしない(例外で処理を中断するために存在)
  catch (e) {
    console.error(e);
  }
};

// データを読み込む
onMounted(() => {
  init();
});
</script>

<template>
  <div>
    <PostContainer
      v-if="post !== null"
      container-type="detail"
      :login-user-id="userId"
      :post="post"
    />
    <teleport to="#js-post-comment">
      <DirectComment />
    </teleport>
    <teleport to="#js-comments">
      <CommentThreads />
    </teleport>
  </div>
</template>
